const HEARTBEAT_INTERVAL_MS = 60 * 1000

export default defineNuxtPlugin(() => {
	const online = useOfflinePosConnectivity()
	let heartbeatTimer
	let heartbeatRunning = false
	let lastHeartbeatAt = 0

	const clearLostReservation = async () => {
		localStorage.removeItem("sv_pos_device_id")
		localStorage.removeItem("sv_pos_branch_id")
		localStorage.removeItem("sv_pos_reservation_id")
		localStorage.removeItem("sv_pos_reservation_user_id")
		await navigateTo("/pos/device-id")
	}

	const heartbeat = async () => {
		if (heartbeatRunning) return
		if (!online.value) return
		if (Date.now() - lastHeartbeatAt < 5000) return
		const posId = localStorage.getItem("sv_pos_device_id")
		const reservationId = localStorage.getItem("sv_pos_reservation_id")
		if (!posId || !reservationId) return

		heartbeatRunning = true
		lastHeartbeatAt = Date.now()
		try {
			await $fetch("/api/poses/heartbeat", {
				method: "POST",
				body: {
					pos_id: posId,
					reservation_id: reservationId,
				},
			})
		} catch (error) {
			if (error?.statusCode === 409) await clearLostReservation()
		} finally {
			heartbeatRunning = false
		}
	}

	onNuxtReady(() => {
		heartbeat()
		heartbeatTimer = window.setInterval(heartbeat, HEARTBEAT_INTERVAL_MS)
		document.addEventListener("visibilitychange", () => {
			if (document.visibilityState === "visible") heartbeat()
		})
	})
})
